<template>
  <div>
    <div class="container-fluid">
      <div class="form py-4 col-lg-6 col-md-7 col-sm-9 col-11 mx-auto">
        <h4 class="text-center my-2 form-heading">Company Information</h4>

        <h6 class="text-center mb-2 form-heading">
          Provide company information
        </h6>

        <p
          class="errors mb-4 col-lg-11 col-md-10 col-11 col-sm-10 mx-auto"
          id="error"
          v-show="NewError"
        ></p>
        <p
          class="success mb-3 col-lg-11 col-md-10 col-11 col-sm-10 mx-auto"
          id="success"
          v-show="success"
        ></p>
        <form method="POST">
          <div class="form-group col-lg-11 mx-auto col-md-10 col-11 col-sm-10">
            <input
              type="text"
              class="form-control"
              placeholder="Enter company name"
              name="companyName"
              id="companyName"
              v-model="companyInfo.companyName"
              autocomplete="autocomplete_off_hack_xfr4!k"
              required
            />
            <!-- <label class="form-label" for="companyName">Company name</label> -->
          </div>
          <div class="form-group col-lg-11 mx-auto col-md-10 col-11 col-sm-10">
            <input
              type="text"
              class="form-control"
              placeholder="Enter company headquater"
              name="companyhquater"
              id="companyhquater"
              v-model="companyInfo.headquater"
              autocomplete="autocomplete_off_hack_xfr4!k"
              required
            />
            <!-- <label class="form-label" for="companyhquater">Company Headquater</label> -->
          </div>
          <div class="form-group col-lg-11 mx-auto col-md-10 col-11 col-sm-10">
            <input
              type="number"
              class="form-control"
              placeholder="Enter company number of buses"
              name="numberOfBuses"
              id="numberOfBuses"
              v-model="companyInfo.numberOfBuses"
              autocomplete="autocomplete_off_hack_xfr4!k"
              required
            />
            <!-- <label class="form-label" for="numberOfBuses">Company number of buses</label> -->
          </div>
          <div class="labels-container col-lg-11 mx-auto">
            <label for="licence" class="pl-1 photo-label"
              >Company driving licence photo</label
            >
            <label for="logo" class="ml-4 pl-1 photo-label">company Logo</label>
          </div>
          <div
            class="uploads d-flex mb-2 col-lg-11 mx-auto col-md-10 col-11 col-sm-10"
          >
            <div
              class="company-driving-licence"
              id="licence"
              @click="$refs.licenceUpload.click()"
            >
              <img
                v-if="companyInfo.licence"
                class="preview"
                :src="companyInfo.licence"
                alt
              />
              <input
                type="file"
                @change="onFileChangeTwo"
                class="form-control-file upload-file"
                ref="licenceUpload"
                name="licence-upload"
                id="licence-upload"
              />
            </div>
            <div
              class="company-logo"
              id="logo"
              @click="$refs.logoUpload.click()"
            >
              <img
                v-if="companyInfo.logo"
                class="preview"
                :src="companyInfo.logo"
                alt
              />
              <input
                type="file"
                @change="onFileChange"
                ref="logoUpload"
                class="form-control-file upload-file"
                name="licence-upload"
                id="licence-upload"
              />
            </div>
          </div>

          <div class="text-center">
            <button
              type="submit"
              @click.prevent="RegisterCompany()"
              class="btn btn_styles login btn-md btn-primary"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
      <div>
        <p class="text-center end">Powered by Zexos Group</p>
      </div>
    </div>
  </div>
</template>

<script>
const url = "https://bookinga.herokuapp.com/api/v1/company/";
import axios from "axios";
import router from "./../../router/index";

const companyId = localStorage.getItem("companyId");
const token = localStorage.getItem("jwt");
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      NewError: false,
      logo: "",
      success: false,
      licence: "",
      companyInfo: {
        companyName: "",
        headquater: "",
        numberOfBuses: "",
        logo: "",
        licence: "",
      },
    };
  },
  created() {

    // if (userRole != "admin") {
    //   return router.push("/dashboard");
    // } else if (userRole == "admin" && $store.state.UserDetails.user.number > 1) {
    //   return router.push("/admin/dashboard");
    // } else if (userRole == "admin" && $store.state.UserDetails.user.number >= 1) {
    //   if (companyId != 0) {
    //     return router.push("/admin/companyDetailsRegistration");
    //   }
    // }
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    onFileChange(e) {
      this.logo = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event) => {
        this.companyInfo.logo = event.target.result;
      };
    },
    onFileChangeTwo(e) {
      this.licence = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event) => {
        this.companyInfo.licence = event.target.result;
      };
    },
    RegisterCompany() {
      if (
        this.companyInfo.numberOfBuses == "" ||
        this.companyInfo.companyName == "" ||
        this.companyInfo.headquater == ""
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "All the fields are required";
      } else if (this.companyInfo.companyName.length < 3) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Company name should be minimum three characters";
      } else {
        const fd = new FormData();
        fd.append("companyName", this.companyInfo.companyName);
        fd.append("headquarter", this.companyInfo.headquater);
        fd.append("noBuses", this.companyInfo.numberOfBuses);
        fd.append("photo", this.logo);
        fd.append("photo", this.licence);
        var token = localStorage.getItem("jwt");
        const headers = { Authorization: `Bearer ${token}` };
        axios
          .post(url, fd, { headers })
          .then((response) => {
            if (response.data.status == 201) {
              this.NewError = false;
              this.success = true;
              (this.companyInfo.companyName = ""),
                (this.companyInfo.headquater = ""),
                (this.companyInfo.numberOfBuses = ""),
                (this.companyInfo.logo = ""),
                (this.companyInfo.licence = "");
              axios.get(url, config).then((res) => {
                var data = res.data.message;
                for (let i = 0; i < data.length; i++) {
                  if (data[i].company_admin == this.AdminId) {
                    this.companyName = this.capitalize(data[i].companyname);
                    localStorage.setItem("companyName", this.companyName);
                    localStorage.setItem("companyId", data[i].id);
                  } else {
                    localStorage.setItem("companyId", 0);
                  }
                }
              });
              document.getElementById("success").innerHTML =
                "New company registered successfuly";
              // localStorage.setItem("companyId",);
              return router.push("admin/companyDetailsRegistration");
            } else {
              this.NewError = true;
              return (document.getElementById("error").innerHTML =
                response.data.message);
            }
          })
          .catch((error) => {
            this.NewError = true;
            return (document.getElementById("error").innerHTML = error.message);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-file {
  display: none;
}
.preview {
  width: 100%;
  height: 100%;
}
.company-logo,
.company-driving-licence {
  height: 40vh;
  width: 49%;
  margin: 10px;
  background-color: rgb(236, 236, 250);
  border: 1px dashed grey;
}
.password-recap {
  float: inherit;
}
.form-group {
  margin-bottom: 0;
}
a {
  color: $mainBlue !important;
  font-size: 0.9em;
}
</style>
